<template>
    <CDropdown style="display: flex" variant="nav-item">
        <CDropdownToggle class="lang-header py-0" :caret="false">
            <img class="dropdown-item-lang-img" :src="flag[localeFromStore]" alt="flag">{{ defaultLang }}
        </CDropdownToggle>

        <CDropdownMenu style="padding: 0">
            <CDropdownItem
                v-for="item in languages"
                :key="item.locale"
                @click="changeLang(item)"
                class="dropdown-item dropdown-item-lang"
            >
                <img class="dropdown-item-lang-img" :src="item.img" alt="flag">
                {{ item.name }}
            </CDropdownItem>
        </CDropdownMenu>
    </CDropdown>
</template>

<script>
import {computed} from 'vue'
import usa from '@/assets/images/flags/us.png'
import ukr from '@/assets/images/flags/ua.png'

export default {
    name: 'LanguageSwitcher',

    data() {
        return {
            flag: {
                en: usa,
                ua: ukr,
            },
            defaultLang: 'Українська',
            localeFromStore: computed(() => this.$store.getters['app/getSelectedLocale']),
            languages: [
                {
                    name: 'English',
                    locale: 'en',
                    img: usa
                },
                {
                    name: 'Українська',
                    locale: 'ua',
                    img: ukr
                },
            ],
        }
    },
    mounted() {
        this.defineLocal()
    },
    watch: {
        localeFromStore() {
            this.defineLocal()
        }
    },
    methods: {
        defineLocal() {
            for (let i of this.languages) {
                if (i.locale === this.$store.getters['app/getSelectedLocale']) {
                    this.defaultLang = i.name;
                    this.$i18n.locale = i.locale
                }
            }
        },
        changeLang(item) {
            const payload = {
                _method: "PUT",
                language: item.locale,
            }
            this.$store.dispatch('app/changeLocale', payload).then(() => {
                this.defaultLang = item.name
                this.$i18n.locale = item.locale
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.lang-header {
    display: flex;
    align-items: center;
    color: rgba(44,56,74,0.95) !important;
}

.dropdown-item-lang {
    display: flex;
    align-items: center;

    &-img {
        margin-right: 4px;
        width: 16px;
        height: 11px;
    }

   
}
</style>

